//import {DragDropModule} from '@angular/cdk/drag-drop';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { NgModule } from '@angular/core';
//import {
//    MatAutocompleteModule,
//    MatBadgeModule,
//    MatBottomSheetModule,
//    MatButtonModule,
//    MatButtonToggleModule,
//    MatCardModule,
//    MatCheckboxModule,
//    MatChipsModule,
//    MatDatepickerModule,
//    MatDialogModule,
//    MatDividerModule,
//    MatExpansionModule,
//    MatGridListModule,
//    MatIconModule,
//    MatInputModule,
//    MatListModule,
//    MatMenuModule,
//    MatNativeDateModule,
//    MatPaginatorModule,
//    MatProgressBarModule,
//    MatProgressSpinnerModule,
//    MatRadioModule,
//    MatRippleModule,
//    MatSelectModule,
//    MatSidenavModule,
//    MatSliderModule,
//    MatSlideToggleModule,
//    MatSnackBarModule,
//    MatSortModule,
//    MatStepperModule,
//    MatTableModule,
//    MatTabsModule,
//    MatToolbarModule,
//    MatTooltipModule,
//    MatTreeModule,
//} from '@angular/material';

@NgModule({
    exports: [
        CdkTableModule,
        CdkTreeModule,
        //MatAutocompleteModule,
        //MatBadgeModule,
        //MatBottomSheetModule,
        //MatButtonModule,
        //MatButtonToggleModule,
        //MatCardModule,
        //MatCheckboxModule,
        //MatChipsModule,
        //MatStepperModule,
        //MatDatepickerModule,
        //MatDialogModule,
        //MatDividerModule,
        //MatExpansionModule,
        //MatGridListModule,
        //MatIconModule,
        //MatInputModule,
        //MatListModule,
        //MatMenuModule,
        //MatNativeDateModule,
        //MatPaginatorModule,
        //MatProgressBarModule,
        //MatProgressSpinnerModule,
        //MatRadioModule,
        //MatRippleModule,
        //MatSelectModule,
        //MatSidenavModule,
        //MatSliderModule,
        //MatSlideToggleModule,
        //MatSnackBarModule,
        //MatSortModule,
        //MatTableModule,
        //MatTabsModule,
        //MatToolbarModule,
        //MatTooltipModule,
        //MatTreeModule,
    ]
})
export class MaterialModule { }


/**  Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */